document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(),
		d = new Date(),
		n = d.getFullYear(),
		win = $(window),
		page = $('html, body'),
		pageUrl = window.location.href,		
		i = 0;

	// WP Remove <p> tags
	$('div.row p:empty').hide();
	

	$('.wpcf7-field-group-remove,.wpcf7-field-group-add,.contact-form .wpcf7-submit').addClass('btn btn-primary');

	$('.img-container').append('<div class="small-circle"></div>');

	$('.post-edit-link').attr('target','_blank');

	// 
	if ( $("body.archive.paged").hasClass("post-type-archive-podcasts") ) {
		var divLoc = $('.section__podcats-profiles--list').offset();
		$('html, body').animate( { scrollTop: divLoc.top - 100 }, "slow" );
	}

	if ($('body.home .table-striped').length > 0) {
		$('body.home .table-striped').DataTable({ searching: false, paging: false, info: false, responsive: true });
	}

	if (win.width() < 1200) {
		
		$('.col-categories').on('click', function() {
			$('.col-categories ul').addClass('active').toggle();
		});
	}

	//Add download attribute in logo page
	$(".logo_downloads a").attr("download", 'ship-energy');


	//loadmore magazines by years
	var cards = $(".card__publications .cardrow");
	$(cards).hide();
	if (cards.length > 0) {
        cards.slice(0, 4).show();
    }
	$("#seeMore").click(function(e){
		e.preventDefault();
		$(".card__publications .cardrow:hidden").slice(0,1).fadeIn("slow");		
		if($(".card__publications .cardrow:hidden").length == 0){
			$("#seeMore").fadeOut("slow");
		}
	});

	$('.bpi-regions-list .bpi-regions-list_item').each(function(){
		var t = $(this).children().find('.h6').text().replace('&', '').replace(/\s+/g, '-').toLowerCase();
		$(this).addClass('bpi-reg--' + t).attr('data-t','bpi-reg--' + t);
		setTimeout(function() {
			$('.bpi-reg--' + t).one('click',function() {
				$('.bpi-tabs--nav .tab-control').removeClass('active');
				$('.bpi-tabs--nav .tab-control.bpi-reg--' + t).click();
			});
		}, 200);
	});

	$('.bpi-reg--north-america,.bpi-reg--south-america,.bpi-reg--south-europe,.bpi-reg--north-europe,.bpi-reg--africa-middle-east,.bpi-reg--asia-oceania,.bpi-reg--caribbean-central-america').on('click', function(){
		$('.bpi-regions-list_item').removeClass('active');
		$(this).addClass('active');
		$('.bpi-tabs--nav .tab-control.active').each(function(){
			var active_class = $(this).attr('data-t');
			$('.bpi-regions-list_item').removeClass('active');
			$('div.' + active_class).addClass('active');
		});
	});

	$('.bpi-reg--all').on('click',function() {
		$('.bpi-regions-list_item').removeClass('active');
	});

	$('body.page-template-tpl-myaccount .woocommerce-MyAccount-navigation-link--dashboard').removeClass('is-active');

	//modal event-reviews mobile view
    $("#openModalReviews").on("click", function () {
        $("#reviewsModal").fadeIn();
    });

	var btnCloseMobile = function() {
		if (window.innerWidth <= 1024) { 
			$("#closeModalReviews").on("click", function () {
				$("#reviewsModal").fadeOut();
			});
		}
	}
	btnCloseMobile();

	window.addEventListener('resize', function(event) {
		btnCloseMobile();
	}, true);

    $(document).on("click", function (e) {
        if ($(e.target).is("#reviewsModal")) {
            $("#reviewsModal").fadeOut();
        }
    });

	/*Port search clone in differnt place on mobile*/
	var $portSearchable = $('.port-searchable');
	var $originalParent = $portSearchable.parent();
	var $nextSibling = $portSearchable.next();
	var isInMobile = false;

	function movePortSearchable() {
		var isMobile = window.innerWidth < 1200;
		var $current = $('.port-searchable');

		if (isMobile && !isInMobile) {
			$current.appendTo('.portSearchTitleBar');
			isInMobile = true;
		} else if (!isMobile && isInMobile) {
			if ($nextSibling.length) {
				$current.insertBefore($nextSibling);
			} else {
				$current.appendTo($originalParent);
			}
			isInMobile = false;
		}
	}

	movePortSearchable();
	$(window).resize(movePortSearchable);



	 function adjustPlaceholder() {
		if (window.innerWidth < 1200) {
			$('#portsearch input[type="text"]').attr('placeholder', 'Search ports');
		} else {
			$('#portsearch input[type="text"]').attr('placeholder', 'Search ports for quick price index');
		}
	}

	adjustPlaceholder(); 
	$(window).resize(adjustPlaceholder);
	
});